import { Text, View } from '@react-pdf/renderer';
import { dateObjToLocalZone, trimString } from '../../utils/converter';
import { infoBoxes } from '../../styles/pdfStyles/infoBoxStyles';

const FileDetailsPDF = ({ reportData }) => {
  return (
    <View style={[infoBoxes.container, infoBoxes.fileDetailsContainer]}>
      <Text style={infoBoxes.title}>File Details</Text>

      <View style={infoBoxes.section}>
        <Text style={infoBoxes.label}>Name:</Text>
        <Text style={infoBoxes.value}>{trimString(reportData.FILE_NAME)}</Text>
      </View>

      <View style={infoBoxes.section}>
        <Text style={infoBoxes.label}>Hash:</Text>
        <Text style={infoBoxes.value}>
          {reportData.HASH.split('').map((char, idx) => (
            <Text key={idx}>{char}</Text>
          ))}
        </Text>
      </View>
    </View>
  );
};

export default FileDetailsPDF;
